'use client';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { Box } from '@s7/base';
import { Flex, SimpleGrid, packSX } from '@s7/layout';
import { rem } from '@s7/styles';
import { Typography } from '@s7/ui';
import { AppItem } from '../../slots/AppItem/AppItem.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultTitleProps = {
    size: [
        24,
        28
    ],
    weight: 600,
    preWrap: true,
    breakpoints: {
        "md1.up": {
            size: [
                24,
                32
            ]
        }
    }
};
var styles = function(theme) {
    var _obj;
    return _obj = {
        backgroundColor: theme.palette.background.content,
        borderRadius: theme.fn.borderRadius("2r"),
        padding: rem("32 20"),
        margin: rem("0 -12")
    }, _obj[theme.fn.up("md1")] = {
        padding: rem(24),
        margin: 0
    }, _obj;
};
var ShortLayout = function(props) {
    var sx = props.sx, title = props.title, items = props.items, locale = props.locale, titleProps = props.titleProps, gridProps = props.gridProps, onItemClick = props.onItemClick, _props_renderAppItem = props.renderAppItem, renderAppItem = _props_renderAppItem === void 0 ? AppItem : _props_renderAppItem, others = _object_without_properties_loose(props, [
        "sx",
        "title",
        "items",
        "locale",
        "titleProps",
        "gridProps",
        "onItemClick",
        "renderAppItem"
    ]);
    return /*#__PURE__*/ jsx(Box, _extends({
        sx: [].concat([
            styles
        ], packSX(sx))
    }, others, {
        children: /*#__PURE__*/ jsxs(Flex, {
            breakpoints: {
                "md1.up": {
                    justify: "space-between",
                    direction: "row",
                    align: "center"
                }
            },
            direction: "column",
            spacing: 20,
            children: [
                title && /*#__PURE__*/ jsx(Typography, _extends({
                    variant: "heading"
                }, defaultTitleProps, titleProps, {
                    children: title
                })),
                items && items.length && /*#__PURE__*/ jsx(SimpleGrid, _extends({
                    breakpoints: {
                        "md1.up": {
                            cols: 4,
                            spacing: 8
                        }
                    },
                    cols: 2,
                    spacing: 8,
                    sx: {
                        width: "fit-content"
                    }
                }, gridProps, {
                    children: items.map(function(_param) {
                        var id = _param.id, item = _object_without_properties_loose(_param, [
                            "id"
                        ]);
                        return renderAppItem(_extends({
                            key: id
                        }, item, {
                            locale: locale,
                            onClick: function(event) {
                                return onItemClick == null ? void 0 : onItemClick(_extends({
                                    id: id
                                }, item), event);
                            }
                        }));
                    })
                }))
            ]
        })
    }));
};

export { ShortLayout };
